// extracted by mini-css-extract-plugin
export default {"Preloader":"Preloader_Preloader__vxLDy","Preloader__spinner":"Preloader_Preloader__spinner__mDFQo","spin":"Preloader_spin__2grEZ"};